import React from 'react'
import { Create, useForm } from '@refinedev/antd'
import { Form, Input } from 'antd'
import type { Tables } from '@muaa/shared'

type Meal = Tables<'meals'>

export function MealCreate() {
  const { formProps, saveButtonProps } = useForm<Meal>()

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Meal name is required' }]}
        >
          <Input placeholder="e.g. Chicken, Vegetarian" />
        </Form.Item>
      </Form>
    </Create>
  )
}
